import { render, staticRenderFns } from "./SettingBoolWidget.vue?vue&type=template&id=e1e878ba&scoped=true"
import script from "./SettingBoolWidget.vue?vue&type=script&lang=js"
export * from "./SettingBoolWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e878ba",
  null
  
)

export default component.exports